var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurantDummyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 481 481",
    style: {
      enableBackground: "new 0 0 481 481"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#435A69;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.8,402.2c-21.5,11.7-45.8,19.1-71.5,21.3l1.7,54.4c21.8-1.6,42.8-6.2,62.6-13.2c0.5-24.9,2.2-47.6,6.3-60 C327.2,404,327.5,403.1,327.8,402.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.6,240.6C478.6,109.1,372,2.6,240.5,2.6S2.5,109.1,2.5,240.6c0,95.5,56.2,177.7,137.3,215.7l1.5-61.2 c-50.7-32.7-84.3-89.7-84.3-154.5c0-101.5,82.2-183.7,183.7-183.7s183.7,82.2,183.7,183.7c0,56.4-25.4,106.9-65.5,140.6v66.1 C430.4,406.2,478.6,329,478.6,240.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163,407.1l1.8,59.2c21.4,7.2,44.3,11.4,67.9,12.2l1.7-54.4C208.9,423.3,184.8,417.3,163,407.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.5,283.1c-4.5,26,5.6,57.7,7.3,58c1.7,0.3-6.8-31-3.4-57.2c3.6-27.7,7.4-37.5,9.1-48.6 C326.7,233.5,318,257.1,313.5,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.9,248.4c4.5-26.6,7.3-27.4,9.8-40.1c0.3-1.7-9.3,12.6-13.7,39.2c-4.5,26.6,9.6,55.7,15.5,59.6 C223.9,308.1,206.4,275.1,210.9,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.8,304.9c-6.7-13-4.1-25.5-4.1-25.5c0.5-3.5,1.3,7.8,4,16.4c2.5,7.9,6.9,15.2,15.3,26.8 C144.4,323.5,134.6,316.5,128.8,304.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.3,239.2c0-97.7-79.2-176.8-176.8-176.8S65.6,141.5,65.6,239.2c0,60.1,30,113.1,75.8,145.1l1.4-56.3 c-22.1-9.1-23.4-29.7-23.6-51.6l0.1-2.5v-78.5c0-3.5,1.5-5.8,3.7-5.8h0.1c2.2,0,3.9,2.3,3.9,5.8v79.6h11.6v-79.6 c0-3.5,1.9-5.8,4.1-5.8h0.1c2.2,0,3.5,2.3,3.5,5.8v79.6H159v-79.6c0-3.5,1.7-5.8,3.9-5.8h0.1c2.2,0,3.6,2.3,3.6,5.8v79.6h11.6 v-79.6c0-3.5,2.1-5.8,4.3-5.8h0.1c2.2,0,4.3,2.5,4.3,6l0.2,78.7v1.8c0,21.8-3.3,42.7-26.7,50.9l2.5,70 c21.7,11.1,46.1,17.6,71.9,18.8l2.8-90.2c-18-6.3-38.4-23.6-38.4-57.4c0-41.9,20.7-86.7,46.3-86.7s46.3,44.9,46.3,86.7 c0,33.7-19.5,51-38.4,57.3l2.9,89.9c27.1-2.1,52.6-10.3,75-23.3c10.6-33.6,2.4-17.5-2.6-21.4c-35.8-27.6-22.5-97.3-22.5-97.3 c6.3-32.6,18-55.2,25.2-68.2c7.1-12.8,16.5-16.1,16.5-16.1c6.3,0,11,5.1,11,15.9l0.1,167.3C395.8,340,419.3,292.4,419.3,239.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantDummyLogo);
export default __webpack_public_path__ + "static/media/RestaurantDummyLogo.ff7640c83bfb72643e5f6cf689657fe8.svg";
export { ForwardRef as ReactComponent };